import { apiProxyRequest } from "Api/apiProxyRequest";

import type { OrganizationVoucherResponse } from "./types";

export const getOrganizationVouchersRequest = (organizationId: string) =>
  apiProxyRequest<OrganizationVoucherResponse>(
    `/organizations/${organizationId}/vouchers`
  );
